import { useMcpTool } from 'webmcp-react'
import { ConversationsAnalyticsApi } from 'entities/Analytics/api/conversationsAnalytics'
import { MessagesAnalyticsApi } from 'entities/Analytics/api/messagesAnalytics'
import { CallsAnalyticsApi } from 'entities/Analytics/api/callsAnalytics'
import { ContactsAnalyticsApi } from 'entities/Analytics/api/contactsAnalytics'
import { PerformanceAnalyticsApi } from 'entities/Analytics/api/performanceAnalytics'
import { ConversionsAnalyticsApi } from 'entities/Analytics/api/conversionsAnalytics'
import { CreditUsageAnalyticsApi } from 'entities/Analytics/api/creditUsageAnalytics'
import { type IAnalyticsParams } from 'entities/Analytics/api/types'
import { queryAnalyticsSchema } from 'entities/WebMcp/model/schemas'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'

const API_BY_CATEGORY = {
  conversations: ConversationsAnalyticsApi,
  messages: MessagesAnalyticsApi,
  calls: CallsAnalyticsApi,
  contacts: ContactsAnalyticsApi,
  performance: PerformanceAnalyticsApi,
  conversions: ConversionsAnalyticsApi,
  credit_usage: CreditUsageAnalyticsApi,
} as const

/** Registers the read-only query_analytics tool. Renders nothing. */
export const AnalyticsTools = () => {
  useMcpTool({
    name: 'query_analytics',
    description:
      'Summarize analytics for a date range. category is one of: conversations, messages, calls, contacts, performance, conversions, credit_usage. Returns metric totals with prior-period comparison.',
    input: queryAnalyticsSchema,
    annotations: { readOnlyHint: true },
    handler: async ({ category, from, to, interval, filter }) => {
      try {
        const params: IAnalyticsParams = {
          from,
          to,
          interval,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          filter: filter as IAnalyticsParams['filter'],
        }
        if (category === 'credit_usage') {
          await CreditUsageAnalyticsApi.preloadCreditUsageAnalytics(params)
          const { data } = await CreditUsageAnalyticsApi.getCreditUsageAnalytics(params)
          return okResult({ category, statistic: data.statistic })
        }
        await API_BY_CATEGORY[category].preloadAnalytics(params)
        const { data } = await API_BY_CATEGORY[category].getAnalytics(params)
        return okResult({ category, statistic: data.statistic })
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}
